import React from 'react';
import './NewsContent.css';
import { Link } from 'react-router-dom';

const NewsContent = () => {
    const newsItems = [
        {
            id: 1,

            image: (
                <><Link to="/news/we_have_arrived_uk/"><img src="/Assets/NewsImages/callistus_uk.webp" /></Link></>
            ),

            title: (
                <><Link to="/news/we_have_arrived_uk/"><h2>We have arrived United Kingdom</h2></Link></>
            ),

            content: 'On completion of a successful year and a half of taking over the window covering market in GCC, Callistus Blinds has finally arrived in United Kingdom. We have successfully launched ourselves in UK under the name Callistus UK Ltd. on 6th of August 2020. […]',

            date: '14 September 2020',

            link: '/news/we_have_arrived_uk/'
        },

        {
            id: 2,

            image: (
                <><Link to="/news/callistus-blinds-goes-international/"><img src="/Assets/NewsImages/callistus_dubai.webp" /></Link></>
            ),

            title: (
                <><Link to="/news/callistus-blinds-goes-international/"><h2>Callistus Blinds goes International</h2></Link></>
            ),

            content: 'After conquering the market of window covering in India under the brand name Callistus, Callistus Blinds has gone international by launching its venture in Sharjah UAE […]',

            date: '14 September 2020',

            link: '/news/callistus-blinds-goes-international/'
        }
    ];

    return (
        <div className="NewsPageContent">
            <div className="news-container">
                <div className="Page-Main_Dec sep-page-heading">
                    <nav className="news-breadcrumb" style={{ margin: '4px 0 12px 0', fontSize: '14px', color: '#555', textAlign: 'left' }}>
                        <Link to="/" style={{ color: '#333', textDecoration: 'underline' }}>Home</Link>
                        <span style={{ color: '#777', margin: '0 6px' }}>&gt;</span>
                        <span>All News</span>
                    </nav>
                    <h1 className="Page-title_LowerCase">News</h1>
                </div>

                <div className="news-list">
                    {newsItems.map((item) => (
                        <div key={item.id} className="news-item">
                            <div className="news-image">
                                {item.image}
                            </div>
                            <div className="news-content">
                                {item.title}
                                <p>{item.content}</p>
                                <div className="news-footer">
                                    <Link to={item.link} className="read-more">Read More</Link>
                                    <span className="news-date">{item.date}</span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default NewsContent;